module.exports = function(hljs) {
  return {
    subLanguage: 'xml',
    contains: [
      {
        begin: '<%', end: '%>',
        subLanguage: 'vbscript'
      }
    ]
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/pauloamgomes/Sites/CockpitReactStatic/react-app/node_modules/highlight.js/lib/languages/vbscript-html.js
// module id = 611
// module chunks = 0 1 2 3